import { render, staticRenderFns } from "./FileDocumentOutline.vue?vue&type=template&id=bfb2c120"
import script from "./FileDocumentOutline.vue?vue&type=script&lang=js"
export * from "./FileDocumentOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports